import api from './api';

// Per-page sidebar visibility switch — Settings → Page Visibility. page_key is a sidebar item's
// own route path (e.g. '/cash-market'). No row for a page = visible by default.
export interface PageVisibility {
  page_key: string;
  is_visible: boolean;
}

export const pageVisibilityAPI = {
  list: () => api.get<PageVisibility[]>('/page-visibility'),
  set: (page_key: string, is_visible: boolean) => api.put('/page-visibility', { page_key, is_visible }),
};
